import colors from "../../utils/colors";
import { createUseStyles } from 'react-jss';

var styles = {
  validationBlock: {
    font: {
      size: '1.2rem',
      lineHeight: '1.8rem'
    },
    letterSpacing: '0.02rem',
    color: colors.red[500],
    display: 'block',
    alignItems: 'center',
    margin: {
      left: '0.1rem',
      top: '0.8rem',
      right: '0rem',
      bottom: '0rem'
    },
    textOverflow: 'clip',
    overflowWrap: 'break-word'
  },
  requiredBlock: {
    font: {
      size: '1.2rem',
      lineHeight: '1.8rem'
    },
    letterSpacing: '0.02rem',
    color: colors.blue[600],
    display: 'block',
    alignItems: 'center',
    margin: {
      left: '0.1rem',
      top: '0.8rem',
      right: '0rem',
      bottom: '0rem'
    },
    textOverflow: 'clip',
    overflowWrap: 'break-word'
  },
  validationMessage: {
    marginLeft: '0.4rem'
  },
  validationIcon: {
    verticalAlign: '-0.18rem'
  }
};
var createStyles = createUseStyles(styles);

export { createStyles };
//# sourceMappingURL=styles.js.map